export default __webpack_public_path__ + "static/media/pencil-purple.d0f74aa4.svg";